import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    eventDetails: {},
};

const cartEventSlice = createSlice({
    name: "cart_cart",
    initialState,
    reducers: {
        addToCart: (state, action) => {
            state.eventCartItems = action.payload
        },
        clearEventCart: (state) => {
            state.eventCartItems = {};
        },
    },
});

export const { addToCart, clearEventCart } = cartEventSlice.actions;
export default cartEventSlice.reducer;
